<template>
  <component :is="message" :question="question" :answer="answer" />
</template>

<script>
import ScoreMessage from '@/components/messages/ScoreMessage'
import SingleMessage from '@/components/messages/SingleMessage'
import TitleMessage from '@/components/messages/TitleMessage'
import MapMessage from '@/components/messages/MapMessage'

export default {
  name: 'AnswerMessage',

  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      messageTypes: {
        score: ScoreMessage,
        single: SingleMessage,
        title: TitleMessage,
        map: MapMessage
      }
    }
  },

  computed: {
    messageType () {
      return this.question.message.type
    },

    message () {
      return this.messageTypes[this.messageType]
    }
  }
}
</script>
